/**
 * `familyTimeline` reducer — the ordered version family for one document.
 *
 * A plain request slice, with one guard worth stating: the timeline is fetched
 * per route, and client-side navigation between two documents' history pages
 * can leave two requests in flight. Each action carries the path it was issued
 * for, and a SUCCESS is applied only if that path is still the one being
 * asked about — otherwise a slow response for the previous family would
 * render under the current family's heading.
 *
 * `data` is deliberately NOT cleared on `_PENDING`: on a client-side
 * navigation the previous list stays on screen until the new one lands, the
 * same stale-while-revalidate choice the search and typeahead slices make.
 *
 * Registered through `config.addonReducers`.
 */
import { GET_FAMILY_TIMELINE } from '../actions/familyTimeline';

const initialState = {
  error: null,
  data: null,
  loaded: false,
  loading: false,
  // The path the CURRENT data describes.
  path: '',
  // The path of the most recent request, whether or not it has landed.
  pendingPath: '',
};

export default function familyTimeline(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_FAMILY_TIMELINE}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
        pendingPath: action.path ?? state.pendingPath,
        // data deliberately untouched — see the header.
      };

    case `${GET_FAMILY_TIMELINE}_SUCCESS`: {
      if (action.path !== state.pendingPath) return state;
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        path: action.path ?? '',
        data: action.result ?? null,
      };
    }

    case `${GET_FAMILY_TIMELINE}_FAIL`:
      if (action.path !== state.pendingPath) return state;
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        data: null,
      };

    default:
      return state;
  }
}
